import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import {
    COMPANY_ADMIN_DATA_IMPORT_ACCOUNT_NUMBERS_ROUTE,
    COMPANY_ADMIN_ROUTE,
} from "../../../../../../constants/routes"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import { ImportResult } from "../../../../../../shared/components/importCsv/ImportResult"

export function CompanyAccountNumbersImportResult() {
    return (
        <>
            <ImportResult>
                <StandardBreadcrumbs>
                    <LocalizedStrict id="company-nav-item-home">
                        <BreadcrumbLink to={COMPANY_ADMIN_ROUTE}>Home</BreadcrumbLink>
                    </LocalizedStrict>
                    <LocalizedStrict id="company-nav-item-data-import">
                        <Breadcrumb>Data import</Breadcrumb>
                    </LocalizedStrict>
                    <LocalizedStrict id="company-nav-item-account-numbers">
                        <BreadcrumbLink to={COMPANY_ADMIN_DATA_IMPORT_ACCOUNT_NUMBERS_ROUTE}>
                            Account numbers
                        </BreadcrumbLink>
                    </LocalizedStrict>
                    <LocalizedStrict id="import-result-breadcrumb">
                        <Breadcrumb>Result</Breadcrumb>
                    </LocalizedStrict>
                </StandardBreadcrumbs>
            </ImportResult>
        </>
    )
}
